(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3360],{

/***/ 42099:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LandingPage": () => (/* binding */ LandingPage),
  "__N_SSP": () => (/* binding */ __N_SSP),
  "default": () => (/* binding */ travel_insurance)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/PreloadImages.tsx




const PreloadImages = pageProps => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    "data-test-id": "PreloadImages-Head",
    children: [pageProps?.data?.claimSettlementText?.icon && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: `${pageProps.data.claimSettlementText.icon}`,
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), pageProps?.data?.travelSearchBanner?.icon && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: `${pageProps.data.travelSearchBanner.icon}`,
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), pageProps?.data?.secureTravData?.[0]?.travImg && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: `${pageProps.data.secureTravData[0].travImg}`,
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), pageProps?.data?.secureTravData?.[1]?.travImg && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: `${pageProps.data.secureTravData?.[1].travImg}`,
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg",
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg",
      as: "image",
      "data-test-id": "PreloadImages-link"
    })]
  });
};

/* harmony default export */ const InsuranceLanding_PreloadImages = (PreloadImages);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/index.tsx + 53 modules
var components = __webpack_require__(58990);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var static_components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/@growth/dweb-footer/dist/growth-dweb-footer.esm.js
var growth_dweb_footer_esm = __webpack_require__(26147);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(48619);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/InsuranceLanding.style.ts



const InsuranceLandingPageMainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__InsuranceLandingPageMainWrapper",
  componentId: "sc-1l4dje5-0"
})(["background-image:linear-gradient(rgba(5,19,34,1),rgba(21,69,124,1));background-size:100% 990px;background-repeat:no-repeat;padding-top:16px;position:relative;z-index:2;@media ", "{background-image:none;padding-top:0px;}"], isomorphic_utils_src.deviceType.mobile);
const InsuranceGiLandingPageMainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__InsuranceGiLandingPageMainWrapper",
  componentId: "sc-1l4dje5-1"
})(["padding-top:16px;position:relative;z-index:2;&:after{content:\"\";position:absolute;top:240px;width:100%;left:0;background-color:#eff3f8;height:1200px;z-index:1;}:before{content:\"\";position:absolute;top:0;width:100%;left:0;background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/Group_1244831888_401a4765df.png\");background-size:100% 382px;background-repeat:no-repeat;height:382px;z-index:2;}@media ", "{background-image:none;padding-top:0px;&:after{background-color:transparent;}}"], isomorphic_utils_src.deviceType.mobile);
const PersuasionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__PersuasionWrapper",
  componentId: "sc-1l4dje5-2"
})(["width:1200px;margin:0 auto;", "{max-width:60%;}"], static_components/* H3TagStyle */.KO);
const LandingPageRightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__LandingPageRightWrapper",
  componentId: "sc-1l4dje5-3"
})(["display:flex;flex-direction:column;gap:24px;"]);
const GiFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__GiFooterWrap",
  componentId: "sc-1l4dje5-4"
})(["width:100%;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/InsuranceBottomComp.tsx



 // Dynamically import SeoContent with server-side rendering disabled

const SeoContent = dynamic_default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 58990)).then(mod => mod.SeoContent), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(58990)]
  }
});






const data = [{
  title: "Popular Flight Sectors",
  links: [{
    text: "Kolkata to Delhi Flight",
    url: "https://www.goibibo.com/flights/kolkata-to-delhi-flights/"
  }, {
    text: "Hyderabad to Delhi Flight",
    url: "https://www.goibibo.com/flights/hyderabad-to-delhi-flights/"
  }]
}];

const InsuranceBottomComp = ({
  bottomCompData,
  footerInfo
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    TravelInsData,
    safeSecureTravel,
    whatsCovered,
    claimYourInsurance,
    testimonials,
    faq,
    customNumbers,
    crossSell,
    offers,
    seoContent
  } = bottomCompData; //TODO: check for if(footerInfo) and remove optional chaining to improve performance

  const footerLinks = footerInfo?.filter(data => data.type === "section")?.map((item, index) => ({
    id: index.toString(),
    label: item.title || "",
    listPoints: item?.links?.map((link, i) => ({
      id: i.toString(),
      label: link.title || "",
      link: link.url || ""
    })) ?? [],
    icon: ""
  })) ?? [];
  const footerHeading = footerInfo?.find(data => data.type === "rich-text");
  const footerCopyrightData = footerInfo?.find(data => data.type === "footnote");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [customNumbers && /*#__PURE__*/(0,jsx_runtime.jsx)(components.InsuranceStats, {
      data: customNumbers,
      "data-test-id": "InsuranceBottomComp-InsuranceStats"
    }), offers && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ExclusiveOffers, {
      data: offers,
      "data-test-id": "InsuranceBottomComp-ExclusiveOffers"
    }), TravelInsData && /*#__PURE__*/(0,jsx_runtime.jsx)(components.WhyBuyTravIns, {
      title: TravelInsData.title,
      info: TravelInsData.info,
      data: TravelInsData.featureCard,
      "data-test-id": "InsuranceBottomComp-WhyBuyTravIns"
    }), safeSecureTravel && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SafenSecureTrav, {
      data: safeSecureTravel.safeTravCrd,
      title: safeSecureTravel.title,
      "data-test-id": "InsuranceBottomComp-SafenSecureTrav"
    }), whatsCovered && /*#__PURE__*/(0,jsx_runtime.jsx)(components.WhatsCovered, {
      data: whatsCovered.travCrd,
      title: whatsCovered.title,
      info: whatsCovered.info,
      "data-test-id": "InsuranceBottomComp-WhatsCovered"
    }), claimYourInsurance && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ClaimYourInsurance, {
      title: claimYourInsurance.title,
      info: claimYourInsurance.info,
      data: claimYourInsurance.claimData,
      "data-test-id": "InsuranceBottomComp-ClaimYourInsurance"
    }), device == "lg" && crossSell && /*#__PURE__*/(0,jsx_runtime.jsx)(PersuasionWrapper, {
      "data-test-id": "InsuranceBottomComp-PersuasionWrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.PersuasionBannerInsurance, {
        crossSell: crossSell,
        btnHandler: () => {
          context === isomorphic_utils_src.PARTNER.GI ? window.open("https://tripmoney.goibibo.com/partners/gi/forex/listing?utm_source=insurance_gi&utm_medium=desktop", "_blank") : window.open("https://www.makemytrip.com/forex", "_blank");
        } // info={persuasionBannerMob.info}
        ,
        "data-test-id": "InsuranceBottomComp-PersuasionBannerInsurance"
      })
    }), testimonials && /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingTestimonials, {
      customTitle: testimonials?.title,
      test: testimonials?.testimonialData,
      "data-test-id": "InsuranceBottomComp-LandingTestimonials"
    }), seoContent && /*#__PURE__*/(0,jsx_runtime.jsx)(SeoContent, {
      seoContent: seoContent,
      "data-test-id": "InsuranceBottomComp-SeoContent"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingFaq, {
      customTitle: faq?.title,
      faq: faq?.faqList,
      "data-test-id": "InsuranceBottomComp-LandingFaq"
    }), bottomCompData?.interlinkingBlock && /*#__PURE__*/(0,jsx_runtime.jsx)(components.InterlinkingBlock, {
      interlinkingBlock: bottomCompData?.interlinkingBlock,
      "data-test-id": "InsuranceBottomComp-InterlinkingBlock"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.Breadcrumb, {
      hostname: context === isomorphic_utils_src.PARTNER.GI ? "www.goibibo.com" : "www.makemytrip.com",
      "data-test-id": "InsuranceBottomComp-Breadcrumb"
    }), context === isomorphic_utils_src.PARTNER.GI && device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(GiFooterWrap, {
      "data-test-id": "InsuranceBottomComp-GiFooterWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(growth_dweb_footer_esm/* Footer */.$, {
        data: data,
        adobe: "",
        "data-test-id": "InsuranceBottomComp-Footer"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingFooter, {
      playStoreImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/play_Store_Icon_ddbbe2de64.png",
      appStoreImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/app_Store_Icon_07d258a1b2.png",
      facebookImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/fb_Icon_8eab71f726.png",
      linkedInImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/Linkedin_Icon_fec59ba5c7.png",
      twitterImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/twitter_Icon_760f145ad2.png",
      footerData: footerLinks,
      footerHeading: footerHeading,
      footerCopyrightData: footerCopyrightData,
      "data-test-id": "InsuranceBottomComp-LandingFooter"
    })]
  });
};

/* harmony default export */ const InsuranceLanding_InsuranceBottomComp = (InsuranceBottomComp);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravellingToShimmer.tsx + 1 modules
var TravellingToShimmer = __webpack_require__(62915);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/InsuranceLandingShimmer.tsx



 //import Header from 'gi-happy-header/ssr/header';
//import { Header  } from 'pwa-mmt-ui-header/ssr/header';




const InsuranceLandingShimmer = () => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* DesktopLayout */.S_, {
      alignCenter: true,
      rightSectionHeight: "unset",
      leftSectionHeight: true,
      landingMargin: true,
      leftComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(static_components/* FlexComp */.bA, {
          gap: "8px",
          flexDirection: "column",
          "data-test-id": "InsuranceLandingShimmer-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
            height: "55px",
            width: device == "lg" ? "375px" : "100px",
            "data-test-id": "InsuranceLandingShimmer-Shimmer"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
            height: "55px",
            width: "100%",
            "data-test-id": "InsuranceLandingShimmer-Shimmer"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
          height: device == "lg" ? "20px" : "10px",
          width: device == "lg" ? "248px" : "100%",
          "data-test-id": "InsuranceLandingShimmer-Shimmer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
          height: device == "lg" ? "80px" : "40px",
          width: "100%",
          "data-test-id": "InsuranceLandingShimmer-Shimmer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
          height: device == "lg" ? "80px" : "40px",
          width: "100%",
          "data-test-id": "InsuranceLandingShimmer-Shimmer"
        })]
      }),
      rightComp: /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToShimmer/* default */.Z, {
        "data-test-id": "InsuranceLandingShimmer-TravellingToShimmer"
      }),
      "data-test-id": "InsuranceLandingShimmer-DesktopLayout"
    })
  });
};

/* harmony default export */ const InsuranceLanding_InsuranceLandingShimmer = (InsuranceLandingShimmer);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/InsuranceLanding.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import "pwa-mmt-ui-header/ssr/header.css";

















const analytics = (0,insurance/* getAnalytics */.I)();

const InsuranceLanding = ({
  data,
  setActiveModal
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  const experiment = (0,react.useContext)(src/* ExperimentTrackingString */.Mq) || "";
  if (!data) return /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_InsuranceLandingShimmer, {
    "data-test-id": "InsuranceLanding-InsuranceLandingShimmer"
  });
  const {
    title,
    claimSettlementText,
    secureTravData,
    travellingTo,
    calendarDatesLimit,
    upcomingTrip,
    upcomingTripsV2,
    errorFields,
    footer,
    travelSearchBanner,
    nextPageRoute,
    analytics: pageAnalytics
  } = data || {};
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: isLoggedIn,
    1: setIsLoggedIn
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const selectedCountries = queryParams.get("countries") || data?.countryCode;
    const selectedCountryCodes = selectedCountries?.split(",");
    let segmentType = queryParams.get("segment");

    if (data?.seoPageType === "SEGMENT" && data?.segmentId) {
      segmentType = data?.segmentId;
    }

    const countryData = travellingTo?.travelSearchForm?.regionCountryList?.value || [];
    let totalCountryData = countryData?.map(data => {
      if (selectedCountryCodes?.includes(data.code)) {
        return _objectSpread(_objectSpread({}, data), {}, {
          isSelected: true
        });
      }

      return _objectSpread({}, data);
    });
    const selectedCountry = totalCountryData?.filter(item => item.isSelected);

    if (countryData?.length) {
      localStorage.setItem("TRAVEL_INSURANCE_COUNTRIES", JSON.stringify(countryData));
    }

    if (data) {
      if (pageAnalytics?.pageLoad) {
        analytics?.trackRawPageLoadEvent(pageAnalytics.pageLoad);
      } else {
        analytics?.trackPageLoadEvent({
          pageName: "LANDING",
          experiment
        });
      }

      (0,XDMAnalytics.initializePageTracking)({
        page_context: {
          page_name: "landing",
          page_type: "landing",
          funnel_step: "landing",
          subpage_name: `seo_landing${data?.travelCountry ? `:${data?.travelCountry}` : ""}`
        }
      }, {
        countries: selectedCountry ? selectedCountry : [],
        journeyType: segmentType || "",
        travellers: parseInt(queryParams.get("travellers") || "1"),
        fromDateTime: queryParams.get("startDate") ? parseInt(queryParams.get("startDate") || "0") : 0,
        toDateTime: queryParams.get("endDate") ? parseInt(queryParams.get("endDate") || "0") : 0
      });
    }
  }, [data]);
  (0,react.useEffect)(() => {
    const authCookie = (0,utils/* getCookieByName */.A7)("mmt-auth") || (0,utils/* getCookieByName */.A7)("OAUTH-GOIBIBO");
    setIsLoggedIn(!!authCookie);
  }, []);

  const goToMyOrders = () => {
    analytics?.trackLandingEvents({
      actionType: "my_orders_clicked"
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "my_orders_clicked"
      }
    });
    const authCookie = (0,utils/* getCookieByName */.A7)("mmt-auth") || (0,utils/* getCookieByName */.A7)("OAUTH-GOIBIBO");

    if (authCookie) {
      navigation/* navigationActionsSeo.navigateToOrderListing */.Ro.navigateToOrderListing();
    } else {
      setActiveModal?.("LOGIN");
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_PreloadImages, {
      data: data,
      "data-test-id": "InsuranceLanding-PreloadImages"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* DesktopLayout */.S_, {
      landingPageProp: true,
      title: title,
      height: device == "lg" ? "720px" : "",
      rightSectionHeight: "unset",
      leftSectionHeight: true,
      landingMargin: true,
      goToMyOrders: goToMyOrders,
      showMyOrders: isLoggedIn,
      leftComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(static_components/* FlexComp */.bA, {
          margin: device == "sm" ? "0 0 0px" : context ? "-30px 0 0" : "",
          alignItems: "center",
          gap: "6px",
          "data-test-id": "InsuranceLanding-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* ImageComponent */.cu, {
            width: "12px",
            height: "16px",
            src: claimSettlementText?.icon,
            loading: "eager",
            "data-test-id": "InsuranceLanding-ImageComponent"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* SpanTag */.pF, {
            fontSize: "xs",
            fontWeight: "bold",
            color: Global/* theme.blackText */.rS.blackText,
            "data-test-id": "InsuranceLanding-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
              value: claimSettlementText?.title,
              "data-test-id": "InsuranceLanding-FormattedText"
            })
          })]
        }), device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.SecureTravOffer, {
          data: secureTravData,
          "data-test-id": "InsuranceLanding-SecureTravOffer"
        }) : ""]
      }),
      rightComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingPageRightWrapper, {
        "data-test-id": "InsuranceLanding-LandingPageRightWrapper",
        children: [upcomingTripsV2 && /*#__PURE__*/(0,jsx_runtime.jsx)(components.DomesticTrip, {
          title: upcomingTripsV2?.title,
          trips: upcomingTripsV2?.trips,
          "data-test-id": "InsuranceLanding-DomesticTrip"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.TravellingTo, {
          travelSearchBanner: travelSearchBanner,
          travellingToSection: travellingTo,
          upcomingTrip: upcomingTrip,
          calendarDatesLimit: calendarDatesLimit,
          nextPageRoute: nextPageRoute,
          errorFields: errorFields,
          countryCodes: data.countryCode,
          setLoginModal: setActiveModal,
          "data-test-id": "InsuranceLanding-TravellingTo"
        }), device != "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SecureTravOffer, {
          data: secureTravData,
          "data-test-id": "InsuranceLanding-SecureTravOffer"
        })]
      }),
      bottomComp: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_InsuranceBottomComp, {
        bottomCompData: data,
        footerInfo: footer,
        "data-test-id": "InsuranceLanding-InsuranceBottomComp"
      }),
      "data-test-id": "InsuranceLanding-DesktopLayout"
    })]
  });
};

/* harmony default export */ const InsuranceLanding_InsuranceLanding = (InsuranceLanding);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/index.tsx


// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/PartnerContext.tsx
var PartnerContext = __webpack_require__(16965);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/Contexts/index.ts

// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hoc/index.ts + 2 modules
var hoc = __webpack_require__(63837);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hoc/index.ts + 5 modules
var lib_hoc = __webpack_require__(99234);
// EXTERNAL MODULE: ../../node_modules/pwa-mmt-ui-header/ssr/header.css
var header = __webpack_require__(4766);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var lib_analytics = __webpack_require__(11508);
// EXTERNAL MODULE: ./src/hoc/index.ts + 1 modules
var src_hoc = __webpack_require__(8367);
;// CONCATENATED MODULE: ./pages/travel-insurance/index.tsx














const travel_insurance_analytics = (0,insurance/* getAnalytics */.I)();
var __N_SSP = true;
function LandingPage({
  data,
  device = "mobile",
  error,
  partner,
  referrer,
  commonsHeaderData
}) {
  const headTags = data?.headTags || {};
  const {
    0: activeModal,
    1: setActiveModal
  } = (0,react.useState)("");
  (0,react.useEffect)(() => {
    const cleanup = (0,lib_analytics/* initGlobalErrorLogging */.mY)("seo_landing");
    return cleanup;
  }, []);
  (0,insurance/* setLandingPageAnalytics */.Q)(data?.analytics?.pageLoad);
  const longImageUrl = data?.offers?.items?.[0]?.image_url;

  const goToMyOrders = () => {
    travel_insurance_analytics?.trackLandingEvents({
      actionType: "my_orders_clicked"
    } //'click'
    );
    const authCookie = (0,utils/* getCookieByName */.A7)("mmt-auth") || (0,utils/* getCookieByName */.A7)("OAUTH-GOIBIBO");

    if (authCookie) {
      navigation/* navigationActionsSeo.navigateToOrderListing */.Ro.navigateToOrderListing();
    } else {
      setActiveModal?.("LOGIN");
    }
  }; // TODO: move header configurations to context


  const component = partner === isomorphic_utils_src.PARTNER.GI ? (0,lib_hoc.withGIInsuranceHeader)( /*#__PURE__*/(0,jsx_runtime.jsx)(PartnerContext/* PartnerContextProvider */.L, {
    partnerType: isomorphic_utils_src.PARTNER.GI,
    "data-test-id": "component-PartnerContextProvider",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_InsuranceLanding, {
      setActiveModal: setActiveModal,
      data: data,
      "data-test-id": "component-InsuranceLanding"
    })
  }), {
    Wrapper: InsuranceGiLandingPageMainWrapper,
    forceLogin: activeModal ? true : false
  }, "Secure International Travel", true, goToMyOrders, false, false) : (0,lib_hoc.withMMTInsuranceHeader)( /*#__PURE__*/(0,jsx_runtime.jsx)(PartnerContext/* PartnerContextProvider */.L, {
    partnerType: isomorphic_utils_src.PARTNER.MMT,
    "data-test-id": "component-PartnerContextProvider",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_InsuranceLanding, {
      setActiveModal: setActiveModal,
      data: data,
      "data-test-id": "component-InsuranceLanding"
    })
  }), {
    type: "dualHeader",
    Wrapper: InsuranceLandingPageMainWrapper,
    activeModal: activeModal ? "LOGIN" : undefined,
    onModalChange: modal => setActiveModal(modal),
    globalConfig: commonsHeaderData?.headerConfig?.value,
    headerCommonData: {
      loyaltyHeaderData: commonsHeaderData?.loyaltyHeaderData?.value,
      walletHeaderData: commonsHeaderData?.walletHeaderData?.value,
      mobileCore: commonsHeaderData?.mobileCore?.value,
      userInfoData: commonsHeaderData?.userInfoData?.value
    }
  }, "Secure International Travel", true, goToMyOrders, false, false, false, false);
  return (0,lib_hoc.withError)((0,hoc/* withReferrerProvider */.ut)((0,src/* withDeviceAndThemeProvider */.OM)((0,src_hoc/* withSeoHeadTags */._)(component, headTags, partner, longImageUrl), device, {
    pageTheme: partner
  }), referrer), error, "LANDING");
}
/* harmony default export */ const travel_insurance = (LandingPage);

/***/ }),

/***/ 28923:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-insurance",
      function () {
        return __webpack_require__(42099);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [4775,98,6966,3633,437,9579,8584,3511,4891,6723,4044,7991,1935,8469,7512,3831,2148,8991,3365,6707,3437,4015,8187,6793,4657,5726,8073,6206,8656,110,9774,8597,8611,9681,1597,500,1285,2346,1516,7556,454,5802,3007,1359,3025,5401,9447,6874,8926,5642,3484,7740,1086,5405,1186,598,9758,179], () => (__webpack_exec__(28923)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);